import type { BioCacheTarget } from '@ps/models/lib/bio-cache-tags';

/**
 * Fire-and-forget request that busts the visitor-bio cache tags for ONE creator
 * entity after an owner mutation. POSTs the {@link BioCacheTarget} to the
 * session-authenticated `/api/my-popstore/revalidate-entity` route, which
 * derives the creator uid from the SESSION (never the body) and calls
 * `revalidateTag` for each `bioEntityTags(uid, target)`.
 *
 * Used both by the central edit-mode bridge (`useEntityCacheInvalidation`) and
 * by mutation sites OUTSIDE the bio editor — community-channel create/delete,
 * subscription tier configure/enable/disable — whose dashboard surfaces don't
 * mount that bridge but still need the visitor bio's main-action gates to
 * refresh promptly.
 */
export function postBioEntityInvalidation(target: BioCacheTarget): void {
  void fetch('/api/my-popstore/revalidate-entity', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ target }),
  }).catch(error => {
    console.error(
      'postBioEntityInvalidation: revalidate request failed:',
      error,
    );
  });
}
